import React from 'react';
import './SlimHeader.css';

type ActiveOverlay = 'none' | 'ecosystem' | 'terminal' | 'gallery';

interface SlimHeaderProps {
  activeOverlay?: ActiveOverlay;
  pagePath?: string; // Optional override for non-overlay pages
}

const SlimHeader: React.FC<SlimHeaderProps> = ({ activeOverlay = 'none', pagePath }) => {
  // Dynamic path based on current context
  const getPath = () => {
    if (pagePath) return pagePath;
    switch (activeOverlay) {
      case 'ecosystem':
        return '/ecosystem/';
      case 'gallery':
        return '/showcase/';
      case 'terminal':
        return '/terminal/';
      default:
        return '/root/';
    }
  };

  return (
    <header className="slim-header" role="banner">
      {/* LHS - Animated Terminal Prompt */}
      <div className="header-prompt">
        <span className="prompt-prefix">_</span>
        <span className="prompt-user">admin</span>
        <span className="prompt-at">@</span>
        <span className="prompt-domain">rodericklrenwick.com</span>
        <span className="prompt-separator"> </span>
        <span className="prompt-path">{getPath()}</span>
        <span className="prompt-symbol"> % </span>
        <span className="prompt-cursor">_</span>
      </div>

      {/* RHS - Online Status */}
      <div className="header-status">
        <span className="status-dot" aria-hidden="true" />
        <span className="status-text">ONLINE</span>
      </div>
    </header>
  );
};

export default SlimHeader;
